import { render } from "./Terms.vue?vue&type=template&id=43f3f128&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=43f3f128&scoped=true&lang=scss"
import "./Terms.vue?vue&type=style&index=1&id=43f3f128&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f3f128"]])

export default __exports__